import { NEW_BASE_URL } from "../Constant";
import { newReconServiceAPI } from "./APIutils";

export function fetchAllOperatorsExpenses({
  pageNo,
  pageSize = 10,
  cityFilter = [],
  operatorFilter = [],
  dateFilter: { fromDate = "", toDate = "" } = {},
}) {
  const url = `${NEW_BASE_URL}/v1/expense/viewExpenses`;
  return newReconServiceAPI(url, {
    pageNo,
    pageSize,
    addOnFilter: {
      cityIdArr: cityFilter,
      operatorIdArr: operatorFilter,
      fromDate,
      toDate,
    },
  });
}

export function createOperatorExpenses({
  cityId = "",
  operatorId = "",
  date = "",
  expenses = {},
}) {
  const url = `${NEW_BASE_URL}/v1/expense/saveExpense`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      cityId,
      operatorId,
      date,
    },
    expenses,
  });
}

export function fetchOperatorExpensesList({
  cityId = "",
  operatorId = "",
  date = "",
}) {
  const url = `${NEW_BASE_URL}/v1/expense/expenseList`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      cityId,
      operatorId,
      date,
    },
  });
}

export function expenseUploadExcelFile(data) {
  const url = `${NEW_BASE_URL}/v1/expense/uploadExpense`;
  return newReconServiceAPI(url, {
    ...data,
  });
}
